module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isFetching) ? _c('div', {
    staticClass: "is-centered has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/loading.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.transactions.length < 1) ? _c('div', [_c('span', [_vm._v("No data found for this user")])]) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.transactions.length > 0) ? _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.transactions,
      "paginated:true": "",
      "per-page": "10",
      "default-sort-direction": "desc",
      "default-sort": "time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "from",
            "label": "Origin",
            "sortable": ""
          }
        }, [_c('b-tag', {
          attrs: {
            "type": _vm.getType(props.row.from),
            "rounded": ""
          }
        }, [_vm._v("\n            " + _vm._s(props.row.from) + "\n          ")])], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "to",
            "label": "Recipient",
            "sortable": ""
          }
        }, [_c('b-tag', {
          attrs: {
            "type": _vm.getType(props.row.to),
            "rounded": ""
          }
        }, [_vm._v("\n            " + _vm._s(props.row.to) + "\n          ")])], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "amount",
            "label": "Assets",
            "sortable": ""
          }
        }, _vm._l((props.row.assets), function(asset) {
          return _c('div', {
            key: asset.name,
            staticStyle: {
              "display": "flex",
              "flex-direction": "row"
            }
          }, [_vm._v("\n            " + _vm._s(Math.abs(asset.qty)) + "\n            "), (asset.name === 'blue') ? _c('img', {
            staticClass: "currency",
            attrs: {
              "src": require("../assets/img/ecoin-blue.png")
            }
          }) : _c('img', {
            staticClass: "currency",
            attrs: {
              "src": require("../assets/img/ecoin-red.png")
            }
          })])
        }), 0), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "time",
            "label": "Date",
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n          " + _vm._s(new Date(props.row.time).toLocaleDateString()) + "\n        ")])]
      }
    }], null, false, 1936928791)
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e8d285","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/History.vue
// module id = 156
// module chunks = 0